import { NoteDto } from '@lmt/shared-types';
import React, { FC } from 'react';
import UrgentNotesIcon from '@lmt/unicorn-shared/app/icons/notes-urgent.svg?react';
import NotesIcon from '@lmt/unicorn-shared/app/icons/notes.svg?react';
import NoteIcon from '@lmt/unicorn-shared/app/icons/note.svg?react';
import NoteUrgentIcon from '@lmt/unicorn-shared/app/icons/note-urgent.svg?react';
import styles from './NoteIconComponent.module.scss';

type Props = {
  notes: NoteDto[];
} & React.SVGAttributes<SVGSVGElement>;

export const NoteIconComponent: FC<Props> = (props) => {
  const { notes, ...rest } = props;
  if (notes.some((x) => x.urgent)) {
    return notes.length > 1 ? (
      <UrgentNotesIcon {...rest} className={styles.urgentNoteIcon} />
    ) : (
      <NoteUrgentIcon {...rest} className={styles.urgentNoteIcon} />
    );
  }
  return notes.length > 1 ? (
    <NotesIcon {...rest} className={styles.noteIcon} />
  ) : (
    <NoteIcon {...rest} className={styles.noteIcon} />
  );
};
